module.exports = __webpack_public_path__ + "media/images/x-89900b7df992bafde6c83ef80b981436.png";